export const makeFieldMeta = (show, changes, invalidFields) => prop => ({
  touched: true,
  error: show && invalidFields[prop] && invalidFields[prop][0],
  modified: changes && Object.prototype.hasOwnProperty.call(changes, prop),
});
